export const showXResultsOptions = [
  { label: '5 results', value: 5 },
  { label: '10 results', value: 10 },
  { label: '15 results', value: 15 },
  { label: '20 results', value: 20 },
  { label: '25 results', value: 25 },
  { label: '30 results', value: 30 },
  { label: '40 results', value: 40 },
]

export const contactSubjects = [
  {
    label: 'General Medicine',
    value: 'general-medicine'
  },
  {
    label: 'Pediatrics',
    value: 'pediatrics'
  },
  {
    label: `Women's Health`,
    value: 'womens-health'
  },
  {
    label: 'Dermatology',
    value: 'dermatology'
  },
  { 
    label: 'Other Inquiry',
    value: 'other'
  },
]

export const socialsArray = [
  {
    name: 'Facebook',
    icon: 'fab fa-facebook-f',
    link: 'https://www.facebook.com'
  },
  {
    name: 'Twitter',
    icon: 'fab fa-twitter',
    link: 'https://www.twitter.com'
  },
  {
    name: 'Instagram',
    icon: 'fab fa-instagram',
    link: 'https://www.instagram.com'
  },
  {
    name: 'LinkedIn',
    icon: 'fab fa-linkedin-in',
    link: 'https://www.linkedin.com'
  },
  {
    name: 'YouTube',
    icon: 'fab fa-youtube',
    link: 'https://www.youtube.com'
  },
]